import googleMap from "./googleMap.js";
import pickerCounter from "./picker-counter.js";
import tiptap from "./tiptap.js";
import "./threads-background.js";
import "./particles-background.js";
import "./aurora-background.js";
import neuralBackground from "./neural-background.js";
import typewriter from "./typewriter.js";
import agentChat from "./agent-chat.js";

Alpine.data('googleMap', googleMap);
Alpine.data('pickerCounter', pickerCounter);
Alpine.data('tiptap', tiptap);
Alpine.data('neuralBackground', neuralBackground);
Alpine.data('typewriter', typewriter);
Alpine.data('agentChat', agentChat);
